/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMetierClauseGridDto
 */
export interface FcbMetierClauseGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbMetierClauseGridDto
     */
    indice?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierClauseGridDto
     */
    idmetier?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierClauseGridDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the FcbMetierClauseGridDto interface.
 */
export function instanceOfFcbMetierClauseGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierClauseGridDtoFromJSON(json: any): FcbMetierClauseGridDto {
    return FcbMetierClauseGridDtoFromJSONTyped(json, false);
}

export function FcbMetierClauseGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierClauseGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indice': !exists(json, 'indice') ? undefined : json['indice'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function FcbMetierClauseGridDtoToJSON(value?: FcbMetierClauseGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indice': value.indice,
        'idmetier': value.idmetier,
        'description': value.description,
    };
}

